/** 纠纷登记列表 */

const App = () => import('@/module/index/layout/App.vue')
const adddispute = () => import('@/module/index/pages/greffier/adddispute.vue')
const disputelist = () => import('@/module/index/pages/greffier/disputelist.vue')
const disputedetail = () => import('@/module/index/pages/greffier/disputedetail.vue')

export default {
  path: '/greffier',
  component: App,
  meta: {
    title: '',
    requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
    isback: true
  },
  children: [{
    path: '/greffier/adddispute',
    component: adddispute
  }, {
    path: '/greffier/adddispute/:id',
    component: adddispute
  }, {
    path: '/greffier/disputelist',
    component: disputelist
  }, {
    path: '/greffier/disputelist/:id',
    component: disputedetail
  }]
}



// WEBPACK FOOTER //
// ./src/publicResource/router/greffier.js